import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from 'src/app/globals';
import { DataStoreService } from 'src/app/services';

@Component({
  selector: 'app-booking-summary-card',
  templateUrl: './booking-summary-card.component.html',
  styleUrls: ['./booking-summary-card.component.css']
})
export class BookingSummaryCardComponent implements OnInit {

  constructor(
    private dataStore: DataStoreService,
    private router: Router,
    globals : Globals
    ) { 
      this.globals = globals;
    }

  store;
  applicantArray;
  passportFeeArray;
  globals : Globals;

  ngOnInit(): void {
    this.store = this.dataStore;

    if (this.store.basketItems.length > 0) {
      for (let index = 0; index < this.store.basketItems.length; index++) {
        const item = this.store.basketItems[index];
        item.$get('resource').then(data => {
          item.counter = data.name;
        });
      }
    }

    this.router.url == '/checklist' && this.dataStore.applicantArray || this.router.url == '/terms-conditions' && this.dataStore.applicantArray ? this.applicantArray = this.dataStore.applicantArray : null;
    this.router.url == '/checklist' && this.dataStore.passportFeeArray || this.router.url == '/terms-conditions' && this.dataStore.passportFeeArray ? this.passportFeeArray = this.dataStore.passportFeeArray : null;
  }
}
